module.exports = __webpack_public_path__ + "static/media/254671640762517416.a3fed8bc.jpg";